import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'external-services' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
